//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    methods: { type: Array, default: () => [] },
  },

  data() {
    return {
      data: {
        makerRoles: [],
        paymentMethods: [],
        limitFrom: undefined,
      },
    };
  },

  computed: {
    getPaymentMethods() {
      return this.$props.methods.map((method, index) => { return { id: index + 1, caption: method }; });
    },
  },

  methods: {
    saveContent() {
      this.$emit('inputExchanger', this.data);
    },

    setPaymentMethods(list) {
      this.data.paymentMethods = list;
      this.saveContent();
    },

    setMakerRole(list) {
      this.data.makerRoles = list;
      this.saveContent();
    },

    setLimitFrom(limit) {
      this.data.limitFrom = Number(limit);
      this.saveContent();
    },
  },
};

